var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.selectedIcon
        ? _c("a-button", { on: { click: _vm.openModal } }, [_vm._v("İkon Seç")])
        : _c(
            "div",
            {
              staticClass: "selected-icon-wrapper",
              on: { click: _vm.openModal },
            },
            [
              _c("i", { class: "material-icons" }, [
                _vm._v(_vm._s(_vm.selectedIcon)),
              ]),
            ]
          ),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c(
            "Modal2",
            {
              attrs: { xlarge: "" },
              on: { cancel: _vm.closeModal },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [_vm._v(" İkon Seçici ")]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                150866389
              ),
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "icon-search" },
                [
                  _c("a-input-search", {
                    attrs: { placeholder: "İkon ara..." },
                    model: {
                      value: _vm.searchQuery,
                      callback: function ($$v) {
                        _vm.searchQuery = $$v
                      },
                      expression: "searchQuery",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "icon-grid" },
                [
                  _vm.searchQuery
                    ? [
                        _c(
                          "div",
                          { staticClass: "icon-items" },
                          _vm._l(_vm.filteredIcons, function (icon) {
                            return _c(
                              "div",
                              {
                                key: icon.name,
                                staticClass: "icon-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.selectIcon(icon.name)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(_vm._s(icon.name)),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    : _vm._l(_vm.groupedIcons, function (icons, category) {
                        return _c(
                          "div",
                          { key: category, staticClass: "icon-category" },
                          [
                            _c("h3", [_vm._v(_vm._s(category))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "icon-items" },
                              _vm._l(icons, function (icon) {
                                return _c(
                                  "div",
                                  {
                                    key: icon.name,
                                    staticClass: "icon-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectIcon(icon.name)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v(_vm._s(icon.name)),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                  _vm._v(" "),
                  _vm._l(10, function (n) {
                    return _vm.isLoading
                      ? _c("div", { key: n, staticClass: "skeleton-loader" })
                      : _vm._e()
                  }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }